<template>
  <main>
    <div class="close-menu">
      <button @click.prevent="$store.dispatch('toggleMenuResponsive', false)" class="btn btn-close-menu"><span
          class="icon-ico-close"></span></button>
    </div>
    <div class="logo">
      <a @click.prevent="$router.push({ name: 'Dashboard' })" href="#"><img src="../assets/img/logo.png"
          class="img-fluid"></a>
      <span>PT POLYTAMA PROPINDO</span>
    </div>
    <nav class="side-menu">
      <div class="accordion" id="accordion-order">
        <router-link :class="{ 'active': activeMenu('dashboard') }" class="link-side" to="/dashboard"><span
            class="icon-ico-dashboard"></span> Dashboard</router-link>
        <router-link v-permissions="'View Report'" :class="{ 'active': activeMenu('report') }" class="link-side"
          to="/reports"><span class="icon-ico-report"></span> Report</router-link>
        <router-link v-permissions="'View Communication Histories'"
          :class="{ 'active': activeMenu('communication-history') }" class="link-side" to="/communication-history"><span
            class="icon-ico-history"></span> Communication History</router-link>
        <router-link v-permissions="'View All Schedules,View My Schedules'" :class="{ 'active': activeMenu('schedule') }"
          class="link-side" to="/schedule"><span class="icon-ico-schedule"></span> Schedule</router-link>
        <router-link v-permissions="'View Target'" :class="{ 'active': activeMenu('target') }" class="link-side"
          to="/target"><span class="icon-ico-target"></span> Target</router-link>
        <div class="side-tabs"
          v-permissions="'View All Feedback and Complaints,View All Feedback and Complaint Labels'">
          <div class="side-tab">
            <input type="checkbox" id="chck1" :checked="checkedMenu('feedback')">
            <label class="side-menu-btn" for="chck1"><span class="icon-ico-feedback"></span> Feedback and Complaint
            </label>
            <div class="menu-content">
              <ul class="link-inside">
                <li v-permissions="'View All Feedback and Complaints'">
                  <router-link :class="{ 'inner-ls active': activeMenu('feedback') }" to="/feedback">Feedback and
                    Complaint</router-link>
                </li>
                <li v-permissions="'View All Feedback and Complaints Labels'">
                  <router-link :class="{ 'inner-ls active': activeMenu('feedback/label') }" to="/feedback/label">Label
                    Management</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- <router-link  :class="{'active': activeMenu('feedback')}" class="link-side" to="/feedback"><span class="icon-ico-feedback"></span> Feedback and Complaint</router-link> -->
        <router-link v-permissions="'View All Broadcasts'" :class="{ 'active': activeMenu('broadcast') }"
          class="link-side" to="/broadcast"><span class="icon-ico-broadcast"></span> Broadcast</router-link>
        <div class="side-tabs" v-permissions="'View Employee Management,View Role Management'">
          <div class="side-tab">
            <input type="checkbox" id="chck2" :checked="checkedMenu('employee')">
            <label class="side-menu-btn" for="chck2"><span class="icon-ico-employee"></span> Employee </label>
            <div class="menu-content">
              <ul class="link-inside">
                <li v-permissions="'View Employee Management'">
                  <router-link :class="{ 'inner-ls active': activeMenu('employee') }" to="/employee">Employee
                    Management</router-link>
                </li>
                <li v-permissions="'View Role Management'">
                  <router-link :class="{ 'inner-ls active': activeMenu('role') }" to="/role">Role
                    Management</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="side-tabs" v-permissions="'View Customer Management,View Label Management'">
          <div class="side-tab">
            <input type="checkbox" id="chck3" :checked="checkedMenu('customer')">
            <label class="side-menu-btn" for="chck3"><span class="icon-ico-customer"></span> Customer</label>
            <div class="menu-content">
              <ul class="link-inside">
                <li v-permissions="'View Customer Management'">
                  <router-link :class="{ 'inner-ls active': activeMenu('customer') }" to="/customer">Customer
                    Management</router-link>
                </li>
                <li v-permissions="'View Label Management'">
                  <router-link :class="{ 'inner-ls active': activeMenu('label') }" to="/label">Label
                    Management</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <router-link v-permissions="'View Prospect'" :class="{ 'active': activeMenu('prospects') }" class="link-side"
          to="/prospects"><span class="icon-ico-prospect"></span> Prospek</router-link>
        <router-link v-role="'Super Admin'" :class="{ 'active': activeMenu('setting-smtp') }" class="link-side"
          to="/setting-smtp"><span class="icon-ico-dashboard"></span> Setting SMTP</router-link>
      </div>
    </nav>
  </main>
</template>

<script>
export default {
  methods: {
    checkedMenu(type) {
      if (type == 'employee') {
        return Boolean(this.$route.path.includes('employee') || this.$route.path.includes('role'))
      } else if (type == 'feedback') {
        return Boolean(this.$route.path.includes('feedback') || this.$route.path.includes('feedback/label'))
      } else if (type == 'customer') {
        if (!this.$route.path.includes('feedback/label')) {
          return Boolean(this.$route.path.includes('customer') || this.$route.path.includes('label'))
        }
      }
    },
    activeMenu(type) {
      let viewUrl = `/${type}`
      let addUrl = `/${type}/add`
      let editUrl = `/${type}/edit`

      if (this.$route.path.includes('/feedback/label')) {
        return Boolean(this.$route.path === '/' + type || this.$route.path === '/' + type + '/add' || this.$route.path.includes('/' + type + '/edit'))
      } else {
        return Boolean(this.$route.path.includes(viewUrl) || this.$route.path.includes(addUrl) || this.$route.path.includes(editUrl))
      }
    }
  }
}
</script>
